const initialState = {
  forms: [],
  formsSubmitted: 0,
};

const getWellTestDetails = (state = initialState, action) => {
  switch (action.type) {
    case "SET_WELL_TEST_DETAILS":
      return {
        ...state,
        forms: [...state.forms, action.form],
      };
    case "UPDATE_WELL_TEST_DETAILS":
      return {
        ...state,
        forms: action.forms,
      };
    case "INCREMENT_SUBMITTED_COUNT":
      return {
        ...state,
        formsSubmitted: state.formsSubmitted + action.count,
      };

    case "RESET_WELL_TEST_STATE":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default getWellTestDetails;
